import moment from 'moment';

const durationFormatter = (locale = 'en') => {
    moment.locale(locale);
    return (unit, period) => moment.duration(unit, period).humanize();
};

export default durationFormatter;
